/**
 * Ported from the Slate-era webpack bundle (src/scripts/sections/product.images.js).
 * Requires shopify-theme-lib.js (Shopify.theme.* globals) and splide.js loaded first.
 */
(function () {
var register = Shopify.theme.sections.register;
var load = Shopify.theme.sections.load;
var ProductForm = Shopify.theme.productForm.ProductForm;
var formatMoney = Shopify.theme.currency.formatMoney;

document.addEventListener("DOMContentLoaded", () => {
  load("product");
});


function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
}

function shopifyHandle(string) {
  string = string.toLowerCase();
  const toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
  // For the old browsers
  for (let i = 0; i < toReplace.length; ++i) {
    string = string.replace(toReplace[i], "");
  }
  string = string.replace(/\W+/g, "-");

  if (string.charAt(string.length - 1) == "-") {
    string = string.replace(/-+\z/, "");
  }
  if (string.charAt(0) == "-") {
    string = string.replace(/\A-+/, "");
  }
  return string;
}

function getUrlwithNewSearchParams(URLsearchParams, action, params) {
  let searchParams = new URLSearchParams(URLsearchParams);
  if (action == "set") {
    for (const key in params) {
      searchParams.set(key, params[key]);
    }
  } else if (action == "delete") {
    searchParams.delete(params);
  }
  return searchParams;
}

document.addEventListener("DOMContentLoaded", () => {
  // Splider image slider
  // ---------
  const splideGroups = document.querySelectorAll(".splide-group");
  splideGroups.forEach((splideGroup, index) => {
    const splideMain = splideGroup.querySelector(".splide-main");
    const splideThumbnails = splideGroup.querySelector(".splide-thumbnails");

    if (!splideMain || !splideThumbnails) {
      return;
    }
    var main = new Splide(splideMain, {
      type: "fade",
      rewind: false,
      pagination: false,
      arrows: true,
      arrowPath: "/"
    });

    var thumbnails = new Splide(splideThumbnails, {
      fixedWidth: 100,
      fixedHeight: 100,
      rewind: false,
      pagination: false,
      cover: false,
      isNavigation: true,
      arrows: false,
      focus: "center",
      updateOnMove: true,
      breakpoints: {
        575: {
          fixedWidth: 60,
          fixedHeight: 60
        }
      }
    });

    main.sync(thumbnails);
    main.mount();
    thumbnails.mount();
  });
});

const classes = {
  hide: "hide",
  sellingPlanSelected: "selling-plan-group-selected"
};

const selectors = {
  buyNowButton: "[data-buy-now]",
  buyNowURL: "[data-buy-now-url]",
  submitButton: "[data-submit-button]",
  submitButtonText: "[data-submit-button-text]",
  comparePrice: "[data-compare-price]",
  comparePriceText: "[data-compare-text]",
  priceWrapper: "[data-price-wrapper]",
  productForm: "[data-product-form]",
  productPrice: "[data-product-price]",
  productQty: "[data-product-qty-container]",
  productSelect: "[data-product-select]",
  bnplAmount: "[data-bnpl-amount]",
  variantImageGroup: "[data-variant-image-group]",
  visibleImageGroup: `[data-variant-image-group]:not(.${classes.hide})`,
  variantImageGroupById: (id) => `[data-variant-image-group='${id}']`,
  sellingPlanGroup: "[data-selling-plan-group]",
  sellingPlanSelect: "[data-selling-plan-select]",
  sellingPlanPrice: "[data-selling-plan-price]",
  sellingPlanComparePrice: "[data-selling-plan-compare-price]",
  sellingPlanAddButton: "[data-add-subscription]",
  sellingPlanRemoveButton: "[data-remove-subscription]"
};

// closest polyfill
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    let el = this;
    do {
      if (el.matches(s)) {
        return el;
      }
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

// parseInt polyfill
if (Number.parseInt === undefined) {
  Number.parseInt = window.parseInt;
}

register("product", {
  async onLoad() {
    const productFormElement = this.container.querySelector(
      selectors.productForm
    );

    this.product = await this.getProductJson(
      productFormElement.dataset.productHandle
    );
    this.productForm = new ProductForm(productFormElement, this.product, {
      onOptionChange: this.onFormOptionChange.bind(this)
    });

    this.onContainerClick = this.onContainerClick.bind(this);
    this.container.addEventListener("click", this.onContainerClick);

    this.variant = this.product.variants.find((item) => {
      return item.id == this.container.dataset.currentVariant;
    });

    if (this.product.selling_plan_groups[0]) {
      this.sellingPlan = this.product.selling_plan_groups[0].selling_plans[0];
    }

    this.sellingPlanSelect = this.container.querySelector(
      selectors.sellingPlanSelect
    );
    if (this.sellingPlanSelect && this.sellingPlan) {
      const _this = this;
      this.sellingPlanSelect.addEventListener("change", function (event) {
        _this.onSellingPlanSelect(event);
      });
    }

    this.onInitalLoad();
  },

  onUnload() {
    this.productForm.destroy();
    this.removeEventListener("click", this.onContainerClick);
  },

  getProductJson(handle) {
    return fetch(`/products/${handle}.js`).then((response) => {
      return response.json();
    });
  },

  onInitalLoad() {
    this.hideFivePackGummies();
    this.autoSelectSellingPlan();
  },

  hideFivePackGummies() {
    // Hide Five Pack Gummies for Canadian & Australian customers
    // -----------------------------------------
    const isACVGummies = this.product.handle == "apple-cider-vinegar-gummies";
    const isSFGummies = this.product.handle == "superfruits-gummies";
    const isASHGummies = this.product.handle == "ashwagandha-gummies";
    if (!isACVGummies && !isSFGummies && !isASHGummies) {
      return;
    }
    const country_code = getCookie("country_code");
    if (country_code && country_code.match(/^(AU|CA)$/)) {
      const fivePackTitle = "5 Bottles";
      const threePackTitle = "3 Bottles";
      if (this.variant.title == fivePackTitle) {
        // change variant to 3 pack
        const threePackVariant = this.product.variants.find((item) => {
          return item.title == threePackTitle;
        });
        this.changeVariant(threePackVariant);
        // set 3 pack option as selected
        const threePackOption = this.container.querySelector(
          `.option-group__values input[value*="${threePackTitle}"]`
        );
        if (threePackOption) {
          threePackOption.checked = true;
        }
        // remove 5 pack option to avoid any add to carts
        const fivePackInput = this.container.querySelector(
          `select[name=id] option[data-title*="${fivePackTitle}"]`
        );
        if (fivePackInput) {
          fivePackInput.remove();
        }
      }
    } else {
      return;
    }
  },

  autoSelectSellingPlan() {
    if (
      !this.container.classList.contains(`tag-autoselect-subscription-widget`)
    ) {
      return;
    }
    if (!this.sellingPlan || !this.sellingPlanSelect) {
      return;
    }
    const sellingPlanStatus = sessionStorage.getItem(this.sellingPlan.id);
    const sellingPlanGroup = this.container.querySelector(
      selectors.sellingPlanGroup
    );
    if (sellingPlanGroup && sellingPlanStatus != "removed") {
      sellingPlanGroup.classList.add(classes.sellingPlanSelected);
      this.container.dataset.sellingPlan = this.sellingPlan.id;
      this.sellingPlanSelect.value = this.sellingPlan.id;
      this.updateBrowserHistory(this.variant, this.sellingPlan);
    }
  },

  changeVariant(variant) {
    this.variant = variant;
    this.container.setAttribute("data-current-variant", variant.id);
    this.renderImageGroup(variant);
    this.renderPrice(variant);
    this.renderComparePrice(variant);
    this.renderSubmitButton(variant);
    this.updateTags(variant);
    this.renderBnplAmount(variant);
    this.updateSelection(variant);
    this.updateBrowserHistory(variant);
  },

  onFormOptionChange(event) {
    const variant = event.dataset.variant;
    this.changeVariant(variant);
  },

  onSellingPlanSelect(event) {
    if (!this.sellingPlan) {
      return;
    }
    const index = event.target.selectedIndex - 1;
    this.sellingPlan = this.product.selling_plan_groups[0].selling_plans[index];
    this.updateBrowserHistory(this.variant, this.sellingPlan);
  },

  onContainerClick(event) {
    const addToCartButton = event.target.closest(selectors.submitButton);
    const buyNowButton = event.target.closest(selectors.buyNowButton);
    const sellingPlanAddButton = event.target.closest(
      selectors.sellingPlanAddButton
    );
    const sellingPlanRemoveButton = event.target.closest(
      selectors.sellingPlanRemoveButton
    );

    if (
      !addToCartButton &&
      !buyNowButton &&
      !sellingPlanAddButton &&
      !sellingPlanRemoveButton
    ) {
      return;
    }
    if (buyNowButton || addToCartButton) {
      const currentVariant = this.container.dataset.currentVariant;
      const productQty = this.container.querySelector(selectors.productQty);
      const productQtyInput = productQty.querySelector("input");

      // if bogo product - auto add x2 items
      if (!this.sellingPlanSelect || !this.sellingPlanSelect.value.length) {
        if (
          this.container.classList.contains(
            `tag-bogo-free-${currentVariant}`
          ) ||
          this.container.classList.contains(`tag-bogo-free-all`)
        ) {
          if (productQtyInput.value == 1) {
            productQtyInput.value = 2;
            // Switch back to default 1 qty (hopefully with enough time to add x2)
            setTimeout(() => {
              if (productQtyInput.value == 2) {
                productQtyInput.value = 1;
              }
            }, 3000);
          }
        }
      }
      if (buyNowButton) {
        event.preventDefault();
        const buyNowUrl = buyNowButton.dataset.buyNowUrl;
        window.location.href =
          buyNowUrl + currentVariant + ":" + productQtyInput.value;
      }
    }
    if (sellingPlanAddButton || sellingPlanRemoveButton) {
      event.preventDefault();
      const sellingPlanGroup = this.container.querySelector(
        selectors.sellingPlanGroup
      );
      if (sellingPlanGroup && this.sellingPlanSelect) {
        if (sellingPlanRemoveButton) {
          this.container.removeAttribute("data-selling-plan");
          sellingPlanGroup.classList.remove(classes.sellingPlanSelected);
          this.sellingPlanSelect.value = "";
          this.updateBrowserHistory(this.variant, "delete");
          sessionStorage.setItem(this.sellingPlan.id, "removed");
        } else if (sellingPlanAddButton) {
          this.container.dataset.sellingPlan = this.sellingPlan.id;
          sellingPlanGroup.classList.add(classes.sellingPlanSelected);
          this.sellingPlanSelect.value = this.sellingPlan.id;
          this.updateBrowserHistory(this.variant, this.sellingPlan);
          sessionStorage.setItem(this.sellingPlan.id, "added");
        }
      }
    }
  },

  renderSubmitButton(variant) {
    const submitButton = this.container.querySelector(selectors.submitButton);
    const submitButtonText = this.container.querySelector(
      selectors.submitButtonText
    );

    if (!variant) {
      submitButton.disabled = true;
      submitButtonText.innerText = theme.strings.unavailable;
    } else if (variant.available) {
      submitButton.disabled = false;
      submitButtonText.innerText = theme.strings.addToCart;
    } else {
      submitButton.disabled = true;
      submitButtonText.innerText =
        this.container.dataset.hasRetailers === "true"
          ? "Where to buy"
          : theme.strings.soldOut;
    }
  },

  renderImageGroup(variant) {
    if (!variant) {
      return;
    }

    const activeGroup = this.container.querySelector(
      selectors.visibleImageGroup
    );
    const inactiveGroup = this.container.querySelector(
      selectors.variantImageGroupById(variant.id)
    );

    if (!inactiveGroup || !activeGroup) {
      return;
    }

    activeGroup.classList.add(classes.hide);
    inactiveGroup.classList.remove(classes.hide);
  },

  renderPrice(variant) {
    const priceElement = this.container.querySelector(selectors.productPrice);
    const priceWrapperElement = this.container.querySelector(
      selectors.priceWrapper
    );

    let variant_price = variant.price;

    // # Custom Sale
    if (
      this.productForm.element.dataset.customSale === "true" &&
      this.product.type !== "Gift Card" &&
      variant.available
    ) {
      let salePercentage = parseFloat(
        this.productForm.element.dataset.customSalePercentage
      );

      if (!isNaN(salePercentage) && salePercentage > 0) {
        let discountMultiplier = 1 - salePercentage / 100;
        variant_price *= discountMultiplier;
      }
    }

    priceWrapperElement.classList.toggle(classes.hide, !variant);

    if (variant) {
      priceElement.innerHTML = formatMoney(
        variant_price,
        theme.moneyWithCurrencyFormat
      );
    }

    const sellingPlanPrice = this.container.querySelector(
      selectors.sellingPlanPrice
    );
    const sellingPlanComparePrice = this.container.querySelector(
      selectors.sellingPlanComparePrice
    );
    if (sellingPlanPrice) {
      sellingPlanPrice.innerHTML = formatMoney(
        variant.selling_plan_allocations[0].per_delivery_price,
        theme.moneyWithCurrencyFormat
      );
    }
    if (sellingPlanComparePrice) {
      sellingPlanComparePrice.innerHTML = formatMoney(
        variant.selling_plan_allocations[0].compare_at_price,
        theme.moneyFormat
      );
    }
  },

  renderComparePrice(variant) {
    if (!variant) {
      return;
    }

    const comparePriceElement = this.container.querySelector(
      selectors.comparePrice
    );
    const compareTextElement = this.container.querySelector(
      selectors.comparePriceText
    );

    if (!comparePriceElement || !compareTextElement) {
      return;
    }

    let variant_compare_at_price = variant.compare_at_price;
    let variant_price = variant.price;

    // if (this.container.classList.contains(`tag-bogo-free-all`)) {
    //   variant_compare_at_price = variant.compare_at_price * 2;
    // }

    // # Custom Sale
    if (
      this.productForm.element.dataset.customSale === "true" &&
      this.product.type !== "Gift Card" &&
      variant.available
    ) {
      let salePercentage = parseFloat(
        this.productForm.element.dataset.customSalePercentage
      );

      if (!isNaN(salePercentage) && salePercentage > 0) {
        let discountMultiplier = 1 - salePercentage / 100;
        variant_compare_at_price = variant_price;
        variant_price *= discountMultiplier;
      }
    }

    if (variant_compare_at_price > variant_price) {
      comparePriceElement.innerHTML = formatMoney(
        variant_compare_at_price,
        theme.moneyFormat
      );
      compareTextElement.classList.remove(classes.hide);
      comparePriceElement.classList.remove(classes.hide);
    } else {
      comparePriceElement.innerText = "";
      compareTextElement.classList.add(classes.hide);
      comparePriceElement.classList.add(classes.hide);
    }
  },

  renderBnplAmount(variant) {
    if (!variant) {
      return;
    }
    const bnplAmountElement = this.container.querySelector(
      selectors.bnplAmount
    );

    if (!bnplAmountElement) {
      return;
    }

    // Hide the installments note when the selected variant is sold out
    const bnplNote = bnplAmountElement.closest(".bnpl-note");
    if (bnplNote) {
      bnplNote.classList.toggle(classes.hide, !variant.available);
    }

    let variant_price = variant.price;

    // # Custom Sale
    if (
      this.productForm.element.dataset.customSale === "true" &&
      this.product.type !== "Gift Card" &&
      variant.available
    ) {
      let salePercentage = parseFloat(
        this.productForm.element.dataset.customSalePercentage
      );

      if (!isNaN(salePercentage) && salePercentage > 0) {
        let discountMultiplier = 1 - salePercentage / 100;
        variant_price *= discountMultiplier;
      }
    }

    bnplAmountElement.innerHTML = formatMoney(
      variant_price / 4,
      theme.moneyFormat
    );
  },

  updateSelection(variant) {
    const productSelect = this.container.querySelector(selectors.productSelect);
    if (!productSelect) {
      return;
    }
    productSelect.value = variant.id;
  },

  updateTags(variant) {
    const variant_handle = shopifyHandle(variant.title);

    const tags = this.container.querySelectorAll("[data-tag]");
    const tagVariants = this.container.querySelectorAll("[data-tag-variant]");
    const tagsOfThisVariant = this.container.querySelectorAll(
      `[data-tag$="${variant_handle}"]`
    );
    if (tagVariants.length && tags.length) {
      tags.forEach(function (tag) {
        tag.classList.remove(classes.hide);
      });
      tagVariants.forEach(function (tag) {
        tag.classList.add(classes.hide);
      });
      if (tagsOfThisVariant.length) {
        tagsOfThisVariant.forEach(function (tag) {
          tag.classList.remove(classes.hide);
        });
      }
    }
  },

  updateBrowserHistory(variant, sellingPlan) {
    const enableHistoryState =
      this.productForm.element.dataset.enableHistoryState;

    if (enableHistoryState !== "true") {
      return;
    }
    let searchParams = window.location.search,
      params = {};
    if (variant) {
      params["variant"] = variant.id;
    }
    if (sellingPlan) {
      if (sellingPlan == "delete") {
        searchParams = getUrlwithNewSearchParams(
          searchParams,
          "delete",
          "selling_plan"
        );
      } else {
        params["selling_plan"] = sellingPlan.id;
      }
    }
    searchParams = getUrlwithNewSearchParams(searchParams, "set", params);
    const url = window.location.pathname + "?" + searchParams.toString();
    window.history.replaceState({ path: url }, "", url);
  }
});

})();
